package or.garden.manager.domain

import io.ktor.client.call.body
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.isSuccess
import karika.distribucija.ba.domain.model.ResultState
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.launch
import or.garden.manager.domain.GardenHttpClient.GARDEN_CLIENT
import or.garden.manager.domain.model.ApiResponse
import or.garden.manager.domain.model.GardenUser
import or.garden.manager.domain.model.GardenUserRequest

internal class AuthApi {
    suspend fun register(payload: GardenUserRequest): Result<HttpResponse> = runCatching {
        return@runCatching GARDEN_CLIENT.post(
            "${GardenHttpClient.baseUrl}/auth/register"
        ) {
            setBody(payload)
        }
    }

    suspend fun login(payload: GardenUserRequest): Result<HttpResponse> = runCatching {
        return@runCatching GARDEN_CLIENT.post(
            "${GardenHttpClient.baseUrl}/auth/login"
        ) {
            setBody(payload)
        }
    }
}

private data object AuthRepository {
    fun register(payload: GardenUserRequest): Flow<ResultState<ApiResponse<GardenUser>>> = flow {
        emit(ResultState.Loading)
        delay(GardenHttpClient.apiDelayMillis)
        try {
            val response = AuthApi()
                .register(payload)
                .getOrNull()
            if (response != null && response.status.isSuccess()) {
                emit(ResultState.Success(response.body()))
                val apiResponse = response.body<ApiResponse<GardenUser>>()
                if (apiResponse.data != null) {
                    GardenHttpClient.token = apiResponse.data.token
                    GardenHttpClient.refreshToken = apiResponse.data.refreshToken
                }
            } else {
                emit(ResultState.Error(response?.body<ApiResponse<String>>()?.message))
            }
        } catch (e: Exception) {
            emit(ResultState.Error("An error occurred. Please try again!"))
        }
    }

    fun login(payload: GardenUserRequest): Flow<ResultState<ApiResponse<GardenUser>>> = flow {
        emit(ResultState.Loading)
        delay(GardenHttpClient.apiDelayMillis)
        try {
            val response = AuthApi()
                .login(payload)
                .getOrNull()
            if (response != null && response.status.isSuccess()) {
                val apiResponse = response.body<ApiResponse<GardenUser>>()
                if (apiResponse.data != null) {
                    GardenHttpClient.token = apiResponse.data.token
                    GardenHttpClient.refreshToken = apiResponse.data.refreshToken
                }
                emit(ResultState.Success(apiResponse))
            } else {
                emit(ResultState.Error(response?.body<ApiResponse<String>>()?.message))
            }
        } catch (e: Exception) {
            emit(ResultState.Error("An error occurred. Please try again!"))
        }
    }
}

data object AuthService {
    fun register(
        payload: GardenUserRequest,
        result: (ResultState<ApiResponse<GardenUser>>) -> Unit
    ) {
        CoroutineScope(Dispatchers.Default).launch {
            AuthRepository
                .register(payload)
                .collect {
                    result(it)
                }
        }
    }

    fun login(
        payload: GardenUserRequest,
        result: (ResultState<ApiResponse<GardenUser>>) -> Unit
    ) {
        CoroutineScope(Dispatchers.Default).launch {
            AuthRepository
                .login(payload)
                .collect {
                    result(it)
                }
        }
    }
}